import { SvgIcon, SvgIconProps } from "@mui/material";

export const CompareIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "25", fill: "none" }}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M20 17.5H4M4 17.5L8 13.5M4 17.5L8 21.5M4 7.5H20M20 7.5L16 3.5M20 7.5L16 11.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DashboardV2Icon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V13M12 8H16V12M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M3 13.3471C3.65194 13.4478 4.31987 13.5 5 13.5C9.38636 13.5 13.2653 11.3276 15.6197 8"
        stroke="#158362"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const InteractionsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V13M12 8H16V12M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M3 13.3471C3.65194 13.4478 4.31987 13.5 5 13.5C9.38636 13.5 13.2653 11.3276 15.6197 8"
        stroke="#158362"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DashboardTooltipIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "17", height: "16", fill: "none" }}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M6.55797 6.00004C6.7147 5.55449 7.02407 5.17878 7.43127 4.93946C7.83847 4.70015 8.31723 4.61267 8.78275 4.69252C9.24827 4.77236 9.67051 5.01439 9.97468 5.37573C10.2789 5.73706 10.4453 6.19439 10.4446 6.66671C10.4446 8.00004 8.44463 8.66671 8.44463 8.66671M8.49797 11.3334H8.50463M15.1646 8.00004C15.1646 11.6819 12.1799 14.6667 8.49797 14.6667C4.81607 14.6667 1.8313 11.6819 1.8313 8.00004C1.8313 4.31814 4.81607 1.33337 8.49797 1.33337C12.1799 1.33337 15.1646 4.31814 15.1646 8.00004Z"
        stroke="#98A2B3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ChatIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "25", fill: "none" }}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6.09436 11.7288C6.03221 11.3282 5.99996 10.9179 5.99996 10.5C5.99996 6.08172 9.60525 2.5 14.0526 2.5C18.4999 2.5 22.1052 6.08172 22.1052 10.5C22.1052 11.4981 21.9213 12.4535 21.5852 13.3345C21.5154 13.5175 21.4804 13.609 21.4646 13.6804C21.4489 13.7512 21.4428 13.801 21.4411 13.8735C21.4394 13.9466 21.4493 14.0272 21.4692 14.1883L21.8717 17.4585C21.9153 17.8125 21.9371 17.9895 21.8782 18.1182C21.8266 18.231 21.735 18.3205 21.6211 18.3695C21.4911 18.4254 21.3146 18.3995 20.9617 18.3478L17.7765 17.8809C17.6101 17.8565 17.527 17.8443 17.4512 17.8448C17.3763 17.8452 17.3245 17.8507 17.2511 17.8661C17.177 17.8817 17.0823 17.9172 16.893 17.9881C16.0097 18.319 15.0524 18.5 14.0526 18.5C13.6344 18.5 13.2237 18.4683 12.8227 18.4073M7.63158 22.5C10.5965 22.5 13 20.0376 13 17C13 13.9624 10.5965 11.5 7.63158 11.5C4.66668 11.5 2.26316 13.9624 2.26316 17C2.26316 17.6106 2.36028 18.1979 2.53955 18.7467C2.61533 18.9787 2.65322 19.0947 2.66566 19.1739C2.67864 19.2567 2.68091 19.3031 2.67608 19.3867C2.67145 19.4668 2.65141 19.5573 2.61134 19.7383L2 22.5L4.9948 22.091C5.15827 22.0687 5.24 22.0575 5.31137 22.058C5.38652 22.0585 5.42641 22.0626 5.50011 22.0773C5.5701 22.0912 5.67416 22.1279 5.88227 22.2014C6.43059 22.3949 7.01911 22.5 7.63158 22.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrangeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "25", fill: "none" }}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g>
        <path
          d="M21 10.5H3M21 13V9.3C21 7.61984 21 6.77976 20.673 6.13803C20.3854 5.57354 19.9265 5.1146 19.362 4.82698C18.7202 4.5 17.8802 4.5 16.2 4.5H7.8C6.11984 4.5 5.27976 4.5 4.63803 4.82698C4.07354 5.1146 3.6146 5.57354 3.32698 6.13803C3 6.77976 3 7.61984 3 9.3V17.7C3 19.3802 3 20.2202 3.32698 20.862C3.6146 21.4265 4.07354 21.8854 4.63803 22.173C5.27976 22.5 6.11984 22.5 7.8 22.5H12M16 2.5V6.5M8 2.5V6.5M14.5 19.5L16.5 21.5L21 17"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const PaymentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "25", fill: "none" }}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g>
        <path
          d="M18.27 7.67578H2.75V17.6958C2.75 19.3458 4.09 20.6758 5.73 20.6758H18.26C19.91 20.6758 21.24 19.3358 21.24 17.6958V10.6658C21.25 9.01578 19.91 7.67578 18.27 7.67578Z"
          stroke="#000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.97998 4.31641H14.11C15.81 4.31641 17.19 5.82641 17.19 7.67641"
          stroke="#000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2.75 11.3567V6.38672" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M11.48 7.67641H4.29C3.44 7.67641 2.75 6.92641 2.75 5.99641C2.75 5.06641 3.44 4.31641 4.29 4.31641H11.48"
          stroke="#000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7099 14.6919C17.9916 14.6919 18.2199 14.4635 18.2199 14.1819C18.2199 13.9002 17.9916 13.6719 17.7099 13.6719C17.4283 13.6719 17.2 13.9002 17.2 14.1819C17.2 14.4635 17.4283 14.6919 17.7099 14.6919Z"
          fill="#000"
          stroke="#000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const ActionsCardArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.16663 6.99984H12.8333M12.8333 6.99984L6.99996 1.1665M12.8333 6.99984L6.99996 12.8332"
        stroke="#106048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ActionsCardArrowLeft = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14px", height: "14px", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.8334 7H1.16671M1.16671 7L7.00004 12.8334M1.16671 7L7.00004 1.16669"
        stroke="#106048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const HotInsightsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "21", fill: "none" }}
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
    >
      <path
        d="M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H14.2C15.8802 20 16.7202 20 17.362 19.673C17.9265 19.3854 18.3854 18.9265 18.673 18.362C19 17.7202 19 16.8802 19 15.2V12M10 7H14V11M13.5 2.5V1M17.4393 3.56066L18.5 2.5M18.5103 7.5H20.0103M1 12.3471C1.65194 12.4478 2.31987 12.5 3 12.5C7.38636 12.5 11.2653 10.3276 13.6197 7"
        stroke="#158362"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const StatisticsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z"
        stroke="#158362"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const DashboardNewFollowersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.0001 15.8369C19.456 16.5683 20.7042 17.742 21.6153 19.2096C21.7957 19.5003 21.886 19.6456 21.9172 19.8468C21.9805 20.2558 21.7009 20.7585 21.32 20.9204C21.1326 21 20.9218 21 20.5001 21M16.0001 11.5322C17.4818 10.7959 18.5001 9.26686 18.5001 7.5C18.5001 5.73314 17.4818 4.20411 16.0001 3.46776M14.0001 7.5C14.0001 9.98528 11.9854 12 9.50008 12C7.0148 12 5.00008 9.98528 5.00008 7.5C5.00008 5.01472 7.0148 3 9.50008 3C11.9854 3 14.0001 5.01472 14.0001 7.5ZM2.55931 18.9383C4.15362 16.5446 6.66945 15 9.50008 15C12.3307 15 14.8465 16.5446 16.4409 18.9383C16.7901 19.4628 16.9648 19.725 16.9446 20.0599C16.929 20.3207 16.758 20.64 16.5496 20.7976C16.282 21 15.9139 21 15.1777 21H3.82244C3.08625 21 2.71816 21 2.45052 20.7976C2.24213 20.64 2.07117 20.3207 2.05551 20.0599C2.03541 19.725 2.21004 19.4628 2.55931 18.9383Z"
        stroke="#158362"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
